module.exports = __webpack_public_path__ + "img/details-book.f7fb2177.webp";